/**
 * @module components\ghChart
 */
import Vue from "vue";
import Component from "vue-class-component";
import highcharts, { ChartOptions } from "highcharts";
import { Prop, Watch } from "vue-property-decorator";
import xrange from "highcharts/modules/xrange.js";
import organization from "highcharts/modules/organization.js";
import oldie from "highcharts/modules/oldie.js";
import sankey from "highcharts/modules/sankey.js";
import exporting from "highcharts/modules/exporting.js";
import highchartsMore from "highcharts/highcharts-more";
import itemSeries from "highcharts/modules/item-series.js";
import funnel from "highcharts/modules/funnel.js";
import histogramBellcurve from "highcharts/modules/histogram-bellcurve.js";
import timeline from "highcharts/modules/timeline.js";
import pareto from "highcharts/modules/pareto.js";
import wordcloud from "highcharts/modules/wordcloud.js";
import venn from "highcharts/modules/venn.js";
import variwide from "highcharts/modules/variwide.js";
import heatmap from "highcharts/modules/heatmap.js";

exporting(highcharts);
sankey(highcharts);
xrange(highcharts);
highchartsMore(highcharts);
funnel(highcharts);
itemSeries(highcharts);
histogramBellcurve(highcharts);
timeline(highcharts);
pareto(highcharts);
wordcloud(highcharts);
oldie(highcharts);
venn(highcharts);
organization(highcharts);
variwide(highcharts);
heatmap(highcharts);

highcharts.setOptions({
  global: {},
  lang: {
    contextButtonTitle: "导出",
    downloadJPEG: "导出jpeg格式",
    downloadPDF: "导出pdf格式",
    downloadSVG: "导出svg格式",
    drillUpText: "上钻",
    viewFullscreen: "全屏",
    downloadPNG: "导出png格式",
    loading: "加载中......",
    months: ["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],
    noData: "没有数据",
    printChart: "打印图表",
    resetZoom: "重置缩放比例",
    resetZoomTitle: "重置缩放标题",
    shortMonths: ["一","二","三","四","五","六","七","八","九","十","十一","十二"],
    weekdays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
  }
});

@Component
export default class GhChart extends Vue {
  @Prop()
  private options: highcharts.Options;
  @Prop({
    default: () => {
      return { width: "100%", height: "100%" };
    }
  })
  private size: {};

  private chart: highcharts.Chart;
  private id = "chart";

  public update(
    redraw?: boolean,
    oneToOne?: boolean,
    animation?: boolean
  ): void {
    if (this.options && this.chart) {
      this.chart.update(this.options, redraw, oneToOne, animation);
    }
  }

  @Watch("options", { deep: true, immediate: true })
  private redraw(val: ChartOptions, oldval: ChartOptions) {
    // this.update();
  }

  mounted() {
    this.chart = highcharts.chart(this.id, this.options);
  }

  public refresh() {
    this.chart = highcharts.chart(this.id, this.options);
  }

  beforeMount() {
    this.id = this.$guid();
  }
}
